export default __webpack_public_path__ + "static/media/iota.b5f17540.png";